import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../ui-sprite-svg/ui-sprite-svg';

const CName = 'ui-trustly-payment-icon';

@customElement(CName)
export class UITrustlyPaymentIcon extends LitElement {
  @property({ type: String }) label = '';

  render() {
    return html`<ui-sprite-svg .iconID=${'payment-methods-trustly-icon'} .label=${this.label}></ui-sprite-svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UITrustlyPaymentIcon;
  }
}
